import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HandsOffHarmony() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="hands-off-harmony" ref={ref} className={`relative w-full pt-12 md:pt-24 pb-12 md:pb-24 bg-gradient-to-b from-[var(--background)] to-[var(--sidebar)] transition-opacity duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
      <div className="container mx-auto px-0 max-w-6xl">
        <div className="text-center">
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-serif text-black tracking-tight">Maximize Your Rental Income. <br />Zero Hassle.&nbsp;&nbsp;</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8 items-start">
          <div className="md:col-span-12 flex flex-col gap-8 text-center pt-8 md:pt-12">
            <p className="text-lg md:text-xl leading-relaxed text-black font-light">We offer a full-service approach to managing&nbsp;<b data-ast-id="f:/src/pages/Home/sections/HandsOffHarmony.tsx|sig:p6gp2p" data-ast-start="1177" data-ast-end="1303">short</b> and <b data-ast-id="f:/src/pages/Home/sections/HandsOffHarmony.tsx|sig:p7fu3g" data-ast-start="1308" data-ast-end="1445">mid-term rentals</b>, taking care of every detail so that you can sit back and relax. We treat your home with the utmost respect, ensuring it is meticulously maintained while our advanced tech stack streamlines the entire lifecycle of every booking, optimizes revenue potential, and transforms your property into a high-performing asset.<br /></p>
            
          </div>
        </div>
      </div>
    </section>;
}